import React from 'react';
import { containerQuery } from '../styles';

// This component is used to apply container queries to the booking widget
// Current styled-components are not compatible with container queries, so we need to use a separate component to apply them.
// TODO: Upgrade styled-components to v6 to use container queries natively. (Introduced breaking changes)
const ContainerQueryStyles = ({ widgetId }: { widgetId: string }) => {
    return (
        <style
            suppressHydrationWarning
            dangerouslySetInnerHTML={{
                __html: containerQuery(widgetId),
            }}
        />
    );
};

export default ContainerQueryStyles;
